import MyTasks from './component';
import _TaskFilter from './TaskFilter';

export default MyTasks;
export const TaskFilter = _TaskFilter;



// WEBPACK FOOTER //
// ./containers/UserDashboard/MyTasks/index.js